// test2554
(2554 && 0);
